module.exports = __webpack_public_path__ + "static/media/w2.89957c86.jpg";